module.exports = __webpack_public_path__ + "img/logo.d70020cb.svg";